export enum ConstructionSiteStateEnums {
  activa = 1,
  suspendida = 2,
  inactiva = 3
}
